<template>
  <div class="right-hello">
    <img src="../assets/img/gongz1.png" alt="">
    <p>信用报告</p>
    <span></span>
    <img src="../assets/img/gongz2.png" alt="">
    <p>信用修复</p>
    <span></span>
    <img src="../assets/img/gongz3.png" alt="">
    <p>异议申诉</p>
    <span></span>
    <img src="../assets/img/xinyongdaikuan.png" alt="">
    <p>信易贷</p>
    <span></span>
    <img src="../assets/img/gongz5.png" alt="">
    <p>移动端</p>
    <span></span>
    <img src="../assets/img/gongz6.png" alt="">
    <p>智能客服</p>
    <div @click="totop" >
      返回顶部
    </div>
  </div>
</template>

<script>

export default {
  methods:{
    totop(){
      window.scrollTo(0, 0);
    }
  }
}
</script>

<style scoped lang="scss">
.right-hello {
  width: 80px;
  height: 406px;
  background: #ffffff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  right: 0;
  top: 40%;
  padding-top: 21px;
  >div {
    width: 100%;
    color: #ffffff;
    height: 40px;
    background: #3584f8;
    text-align: center;
    line-height: 40px;
    margin-top: 16px;
    cursor: pointer;
  }

  >img {
    width: 15px;
    height: 16px;
    cursor: pointer;
  }

  p {
    font-size: 12px;
    color: #333333;
    cursor: pointer;
  }

  >span {
    height: 1px;
    width: 56px;
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.582) 50%, transparent 50%);
    background-size: 4px 100%;
    /* 控制虚线和间隙的宽度 */
    margin: 12px;
  }
}
</style>
